import { multiClientMiddleware } from "redux-axios-middleware";
import * as Routes from "services/network/routes";
import {
  portal,
  sensedia,
  sensediaCorp,
  portalAws,
  httpClient,
  bff,
  bffPub,
} from "./clients";

export const clients = {
  [Routes.PORTAL]: portal,
  [Routes.SENSEDIA]: sensedia,
  [Routes.SENSEDIA_CORP]: sensediaCorp,
  [Routes.PORTAL_AWS]: portalAws,
  [Routes.HTTP_CLIENT]: httpClient,
  [Routes.BFF]: bff,
  [Routes.BFF_PUB]: bffPub,
};

const options = { defaultClientName: Routes.DEFAULT_CLIENT_NAME };

export default multiClientMiddleware(clients, options);



// WEBPACK FOOTER //
// ./src/services/state/middlewares/axios/index.js